import { auctionHouseDetail, auctionHouseUpdate, getOfferRecord } from '@/api';
import { CardItem, HeaderTitle, Operation, Thumbnails } from '@/components';
import { calcPrice, notEmptyObj, parseJSON, toDateTime, toSpliceStr } from '@/utils/utils';
import { st_auction, st_spu, st_user } from '@/utils/statetype';
import { Card, DatePicker, message, Modal, Table } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import locale from 'antd/es/date-picker/locale/zh_CN';

const { statusObj, typeObj } = st_spu;
const { statusObj: statusObjs } = st_user;
const { statusObj: acStatusObj } = st_auction;
function SpuBeatDetail({ querys }) {
  const { i: ID } = querys;
  let times = useRef(null);
  const [datas, setDatas] = useState({});
  const [offerList, setOfferList] = useState([]);
  const [merchant, setMerchant] = useState({});
  const [spuAuction, setSpuAuction] = useState({});

  const handleGetData = () => {
    auctionHouseDetail({
      query: {
        id: Number(ID),
      },
    }).then(res => {
      setDatas(res);
    });
  };

  useEffect(() => {
    handleGetData();
  }, []);

  const renderInfo = [
    {
      label: '拍间编号',
      render: datas.id,
    },
    {
      label: '提交用户编号',
      render: datas.userId,
    },
    {
      label: '拍间名称',
      render: datas.name,
    },
    {
      label: '拍间期限',
      render: `${datas.auctionDuration}小时`,
    },
    {
      label: '拍间状态',
      render: acStatusObj[datas.status] || '-',
    },
    {
      label: '备注信息',
      render: datas.refuseReason,
    },
    {
      label: '开拍时间',
      render: toDateTime(datas.startTime),
    },
    {
      label: '结束时间',
      render: toDateTime(datas.endTime),
    },
    {
      label: '创建时间',
      render: toDateTime(datas.createdAt),
    },
  ];

  const renderSpu = {
    dataSource: datas.Skus,
    columns: [
      {
        title: 'sku编号',
        dataIndex: 'id',
      },
      {
        title: '商品编号',
        dataIndex: 'spuId',
      },
      {
        title: '商品图片',
        dataIndex: 'Spu',
        render: e => <Thumbnails images={[e.thumb]} center />,
      },
      {
        title: '商品名称',
        dataIndex: 'Spu',
        render: e => e.name,
      },
      {
        title: '商品类型',
        dataIndex: 'Spu',
        render: e => typeObj[e.type],
      },
      {
        title: '商品状态',
        dataIndex: 'Spu',
        render: e => statusObj[e.status],
      },
      {
        title: '商品标签',
        dataIndex: 'Spu',
        render: e => e.Labels.map(i => `【${i.name}】`).join(''),
      },
      {
        title: '所属分类',
        dataIndex: 'Spu',
        ellipsis: true,
        render: e => toSpliceStr(parseJSON(e.property) || {}, '>'),
      },
      {
        title: '创建时间',
        dataIndex: 'createdAt',
        render: e => toDateTime(e),
      },
      {
        title: '其它信息',
        flex: 'right',
        render: e => (
          <Operation
            disabled={{
              noOffer: true,
            }}
            hideMenu={{
              noOffer: !!e.SkuOffers.length,
              offerInfo: !e.SkuOffers.length,
              update: ![20, 100].includes(e.status),
            }}
            listData={{
              auctionInfo: () => {
                // const { Skus = [], SpuAuctionHouse = {} } = e;
                // const infos = Skus.find(i => i.id === SpuAuctionHouse.skuId);
                setSpuAuction(e || {});
              },
              merchantInfo: () => setMerchant(e.Spu?.Merchant),
              offerInfo: () => setOfferList(e.SkuOffers || []),
              noOffer: () => { },
              update: () => {
                Modal.confirm({
                  icon: null,
                  title: '更改排期时间',
                  content: (
                    <DatePicker.RangePicker
                      showTime
                      locale={locale}
                      onChange={e => (times.current = e)}
                    />
                  ),
                  onOk: () => handleUpdateTime(ID),
                });
              },
            }}
          />
        ),
      },
    ],
  };

  const handleUpdateTime = id => {
    if (!times || !times.current) {
      return message.warning('时间未输入');
    }
    const [s, e] = times.current;
    auctionHouseUpdate({
      body: {
        id,
        startTime: toDateTime(s),
        endTime: toDateTime(e),
      },
    }).then(() => {
      message.success('修改成功');
      handleGetData();
    });
  };

  const offerColumns = [
    {
      width: 100,
      align: 'center',
      title: '用户编号',
      dataIndex: 'userId',
    },
    {
      width: 100,
      align: 'center',
      title: '商品编号',
      dataIndex: 'spuId',
    },
    {
      width: 100,
      align: 'center',
      title: 'sku编号',
      dataIndex: 'skuId',
    },
    {
      width: 100,
      align: 'center',
      title: '出价价格',
      dataIndex: 'offer',
      render: e => calcPrice(e),
    },
    {
      width: 100,
      align: 'center',
      title: '出价状态',
      dataIndex: 'status',
      render: e => statusObjs[e],
    },
    {
      width: 100,
      align: 'center',
      title: '出价时间',
      dataIndex: 'createdAt',
      render: e => toDateTime(e),
    },
  ];

  const renderSpuAuction = [
    {
      label: '编号',
      render: spuAuction.id,
    },
    {
      label: '类型',
      render: typeObj[spuAuction.type],
    },
    {
      label: '加价幅度',
      render: spuAuction.addPriceRange,
    },
    {
      label: '保证金比例',
      render: spuAuction.bondPro,
    },
    {
      label: '起始价',
      render: calcPrice(spuAuction.startPrice),
    },
    {
      label: '当前价',
      render: calcPrice(spuAuction.currentPrice),
    },
    {
      label: '最终价',
      render: calcPrice(spuAuction.finalPrice),
    },
    {
      label: '开始时间',
      render: toDateTime(spuAuction.startTime),
    },
    {
      label: '结束时间',
      render: toDateTime(spuAuction.endTime),
    },
    {
      label: '创建时间',
      render: toDateTime(spuAuction.createdAt),
    },
  ];

  const renderMerchant = [
    {
      label: '店铺名称',
      render: merchant.title,
    },
    {
      label: '店铺LOGO',
      render: <Thumbnails images={[merchant.shopIcon]} />,
    },
    {
      label: '联系方式',
      render: merchant.contact,
    },
    {
      label: '店铺地址',
      render: merchant.address,
    },
  ];

  return (
    <>
      <HeaderTitle />
      <Card>
        <CardItem title={'基本信息'} datas={renderInfo} />
        <CardItem title={'商品信息'} datas={renderSpu} />
      </Card>
      <Modal
        width={1000}
        footer={null}
        title="出价信息"
        visible={!!offerList.length}
        onCancel={() => setOfferList([])}
      >
        <Table
          bordered
          size="small"
          pagination={false}
          rowKey={row => row.id}
          columns={offerColumns}
          dataSource={offerList}
        />
      </Modal>
      <Modal
        width={600}
        footer={null}
        closable={false}
        destroyOnClose
        visible={notEmptyObj(merchant)}
        onCancel={() => setMerchant({})}
      >
        <CardItem title={'商家信息'} datas={renderMerchant} />
      </Modal>
      <Modal
        width={600}
        footer={null}
        closable={false}
        destroyOnClose
        visible={notEmptyObj(spuAuction)}
        onCancel={() => setSpuAuction({})}
      >
        <CardItem title={'sku'} datas={renderSpuAuction} />
      </Modal>
    </>
  );
}

export default SpuBeatDetail;
